import React, { useState } from "react";
import Login from "./components/Login";
import Sidebar from "./components/Sidebar";
import AdminDashboard from "./components/AdminDashboard";
import UserTasks from "./components/UserTasks";
import DailyReport from "./components/DailyReport";
import ReportList from "./components/ReportList";
import { MdOutlineDescription, MdListAlt, MdOutlineDashboard } from "react-icons/md";
import { FaTasks } from "react-icons/fa";
import "./App.css";

const PAGE_TITLES = {
  admin : { icon:<MdOutlineDashboard />, title:"Admin Dashboard", sub:"Manage tasks, users, and view analytics" },
  users : { icon:<MdOutlineDashboard />, title:"Manage Users",    sub:"Add or remove team members" },
  tasks : { icon:<FaTasks />,           title:"Tasks",            sub:"Track and manage assigned tasks" },
  form  : { icon:<MdOutlineDescription />, title:"New Report",   sub:"Fill and submit your daily work report" },
  list  : { icon:<MdListAlt />,         title:"All Reports",     sub:"View and manage submitted reports" },
};

export default function App() {
  const [user, setUser]         = useState(null);
  const [page, setPage]         = useState("tasks");
  const [editReport, setEditReport] = useState(null);

  const handleLogin = (u) => {
    setUser(u);
    setPage(u.role==="admin" ? "admin" : "tasks");
  };

  const handleLogout = () => { setUser(null); setPage("tasks"); };
  const handleEdit   = (r) => { setEditReport(r); setPage("form"); };
  const handleNew    = ()  => { setEditReport(null); setPage("form"); };

  if (!user) return <Login onLogin={handleLogin} />;

  const isAdmin = user.role === "admin";
  const info    = PAGE_TITLES[page] || PAGE_TITLES.tasks;

  return (
    <div className="app-shell">
      <Sidebar user={user} page={page} setPage={p=>{ setPage(p); if(p==="form") setEditReport(null); }} onLogout={handleLogout} />

      <div className="app-main">
        {/* Top bar */}
        <div className="topbar no-print">
          <div className="topbar-left">
            <div className="topbar-icon">{info.icon}</div>
            <div>
              <h1 className="topbar-title">{info.title}</h1>
              <p className="topbar-sub">{info.sub}</p>
            </div>
          </div>
          <div className="topbar-right">
            <div className="topbar-user">
              <div className="tu-avatar">{user.name.charAt(0)}</div>
              <div className="tu-info">
                <div className="tu-name">{user.name}</div>
                <div className="tu-role">{isAdmin ? "Administrator" : "Employee"}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="page-content">
          {page==="admin" && isAdmin  && <AdminDashboard user={user} />}
          {page==="users" && isAdmin  && <AdminDashboard user={user} />}
          {page==="tasks"             && (isAdmin ? <AdminDashboard user={user} /> : <UserTasks user={user} />)}
          {page==="form"              && <DailyReport editReport={editReport} onSaved={()=>setPage("list")} />}
          {page==="list"              && <ReportList onEdit={handleEdit} onNew={handleNew} />}
        </div>
      </div>
    </div>
  );
}
